import { useTheme } from "@mui/material";
import { Link } from 'react-router-dom';


const CustomFieldLink = (propsParam: { resource: any, record: any, linkField: string }) => {

    const theme = useTheme();

    return (
        <Link to={`/${propsParam.resource}/${propsParam.record?.id}/show`} style={{ color: theme.palette.primary.main }} >{propsParam.record ? propsParam.record[`${propsParam.linkField}`] : ''}</Link>
    )
}

export default CustomFieldLink;